import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import Select from 'react-select';
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import { postUpdateSlaDatas } from "../../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication';
import { baseURL } from "../BaseUrl";
import moment from "moment";
import { ADDED_BY_ID } from "../../Constants";

const statusOptions = [
    { value: 41, label: "In-Process" },
    { value: 42, label: "Hold" },
    { value: 43, label: "Completed" },
];

const UpdateSlaModal = (props) => {
    const dispatch = useDispatch();
    const { singleAssignedToSlaData, assignedToSlaDatas, slaId, open, handleClose, updatedSlaDatas } = props;

    const DepartmentID = singleAssignedToSlaData[0]?.DepartmentID

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const departmentName = signInDetails ? signInDetails[0].DeptName : null;
    const DeptID = signInDetails ? signInDetails[0].DeptID : null;

    // State variables
    const [reportedOn, setReportedOn] = useState(new Date());
    const [achievedPercentage, setAchievedPercentage] = useState("");
    const [departmentID, setDepartmentID] = useState("");
    const [assignedScore, setAssignedScore] = useState("");
    const [checklist, setChecklist] = useState("");
    const [status, setStatus] = useState(null);
    const [scoreData, setScoreData] = useState([]); // Store score range data
    const [errors, setErrors] = useState({});
    const [isEndDateExpired, setIsEndDateExpired] = useState(false);
    const [actualValue, setActualValue] = useState("");

    // Fetch assigned score on page load
    useEffect(() => {
        if (slaId && singleAssignedToSlaData) {
            setChecklist(singleAssignedToSlaData[0]?.SLACategoryName || "");
        }
    }, [slaId, singleAssignedToSlaData]);

    // Fetch SLA Assigned Scores on Page Load
    useEffect(() => {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAAssignedScoreFromAchievedPercentage`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "AchievedPercentage": null })
        })
            .then((resp) => resp.json())
            .then((data) => {
                setScoreData(data.SLAAssignedScoreFromAchievedPercentage); // Store the fetched score mapping
            })
            .catch((error) => console.error("Error fetching SLA Scores:", error));
    }, []);

    useEffect(() => {
        if (slaId && singleAssignedToSlaData?.length > 0 && singleAssignedToSlaData[0]?.EndDate) {
            const endDate = moment(singleAssignedToSlaData[0].EndDate).toDate();
            setIsEndDateExpired(endDate < new Date());
        }
    }, [slaId, singleAssignedToSlaData]);

    // const handleActualChange = (e) => {
    //     let value = e.target.value;

    //     // Ensure value is between 0 and 100
    //     if (value < 0) {
    //         value = "0";
    //     } else if (value > 100) {
    //         value = "100";
    //     }

    //     setActualValue(value);

    //     if (errors.achievedPercentage) {
    //         setErrors((prevErrors) => ({
    //             ...prevErrors,
    //             achievedPercentage: "",
    //         }));
    //     }

    //     if (value === "100") {
    //         setStatus({ value: 43, label: "Completed" });
    //     } else {
    //         setStatus(null);
    //     }

    //     const numericValue = parseFloat(value);
    //     if (!isNaN(numericValue)) {
    //         const matchingScore = scoreData.find(score =>
    //             numericValue >= score.AchievedPercentageFrom && numericValue <= score.AchievedPercentageTo
    //         );
    //         setAssignedScore(matchingScore ? matchingScore.AssignedScore : "");
    //     } else {
    //         setAssignedScore("");
    //     }
    // };

    const handleActualChange = (eOrDate) => {
        const valueType = singleAssignedToSlaData[0]?.ValueType;
        const targetValue = singleAssignedToSlaData[0]?.TargetValue;
        const startValue = singleAssignedToSlaData[0]?.BaseLine;
        let actual;
        if (valueType === 'Date') {
            actual = new Date(eOrDate);
            const targetDate = new Date(targetValue);
            const startDate = new Date(startValue);

            setActualValue(actual);

            // --- Calculate total months and actual completion months ---
            const totalMonths = ((targetDate.getFullYear() - startDate.getFullYear()) * 12 +
                (targetDate.getMonth() - startDate.getMonth())) + 1;

            const actualMonths = ((actual.getFullYear() - startDate.getFullYear()) * 12 +
                (actual.getMonth() - startDate.getMonth())) + 1;

            const diff = totalMonths - actualMonths;
            const ratio = diff / totalMonths;

            let achieved = 0;

            if (diff === 0) {
                achieved = 100;
            } else if (diff > 0) {
                achieved = (100 + (ratio * 100)).toFixed(2); // Early completion
            } else {
                achieved = (-100 + (ratio * 100)).toFixed(2); // Late completion
            }

            setAchievedPercentage(achieved);

            // if (parseFloat(achieved) >= 100) {
            //     setStatus({ value: 43, label: 'Completed' });
            // } else {
            //     setStatus(null);
            // }

            // const matchingScore = scoreData.find(
            //     (score) =>
            //         parseFloat(achieved) >= score.AchievedPercentageFrom &&
            //         parseFloat(achieved) <= score.AchievedPercentageTo
            // );

            // 👉 Score logic updated here
            const achievedVal = parseFloat(achieved);
            let matchingScore;

            if (achievedVal <= 0) {
                matchingScore = scoreData.find(score => score.AchievedPercentageFrom === 0 && score.AchievedPercentageTo === 0);
            } else {
                matchingScore = scoreData.find(score =>
                    achievedVal >= score.AchievedPercentageFrom &&
                    (score.AchievedPercentageTo === 0 || achievedVal <= score.AchievedPercentageTo)
                );
            }

            setAssignedScore(matchingScore ? matchingScore.AssignedScore : '');
        } else {
            // --- Handle non-date value types (Percentage, Number, Dollar) ---
            let value = eOrDate.target.value;

            setActualValue(value);

            if (errors.achievedPercentage) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    achievedPercentage: '',
                }));
            }

            actual = parseFloat(value);
            const target = parseFloat(targetValue || 0);

            if (!isNaN(actual) && target > 0 && ['Percentage', 'Number', 'Dollar'].includes(valueType)) {
                const achieved = ((actual / target) * 100).toFixed(2);
                setAchievedPercentage(achieved);

                if (parseFloat(achieved) === 100) {
                    setStatus({ value: 43, label: 'Completed' });
                } else {
                    setStatus(null);
                }

                // const matchingScore = scoreData.find(
                //     (score) =>
                //         parseFloat(achieved) >= score.AchievedPercentageFrom &&
                //         parseFloat(achieved) <= score.AchievedPercentageTo
                // );

                const achievedVal = parseFloat(achieved);
                let matchingScore;

                if (achievedVal <= 0) {
                    matchingScore = scoreData.find(score => score.AchievedPercentageFrom === 0 && score.AchievedPercentageTo === 0);
                } else {
                    matchingScore = scoreData.find(score =>
                        achievedVal >= score.AchievedPercentageFrom &&
                        (score.AchievedPercentageTo === 0 || achievedVal <= score.AchievedPercentageTo)
                    );
                }

                setAssignedScore(matchingScore ? matchingScore.AssignedScore : '');
            } else {
                setAchievedPercentage('');
                setAssignedScore('');
                setStatus(null);
            }
        }
    };

    const handleStatusChange = (selectedOption) => {
        setStatus(selectedOption);

        if (errors.status) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                status: "",
            }));
        }
    };

    // Determine which statuses should be shown
    const filteredStatusOptions = achievedPercentage === "100"
        ? statusOptions.filter(option => option.label === "Completed")
        : statusOptions;

    const validateForm = () => {
        let formErrors = {};
        if (!achievedPercentage) formErrors.achievedPercentage = "Achieved % is required.";
        if (!status) formErrors.status = "Status is required.";

        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const isDateType = singleAssignedToSlaData[0]?.ValueType === 'Date';
        const formattedAchievedValue = isDateType && actualValue
            ? moment(actualValue).format("DD-MMM-YYYY")
            : actualValue;

        const data = {
            SLAID: slaId,
            ReportedOn: moment(reportedOn).format("DD-MMM-YYYY"),
            AchievedPercentage: parseFloat(achievedPercentage),
            AchievedValue: formattedAchievedValue,
            DepartmentID: DeptID,
            // DepartmentID: DepartmentID,
            AssignedScore: assignedScore,
            Checklist: checklist,
            StatusID: status ? status.value : null,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // console.log("Submitted Data:", data);
        dispatch(postUpdateSlaDatas(requestOption, props.handleClose, updatedSlaDatas));
    };

    return (
        <Modal show={open} onHide={handleClose} className='add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Update SLA</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={6}>
                                <div className='add-customer-calendar-container'>
                                    <label>Report Date</label>
                                    <DatePicker
                                        showIcon
                                        toggleCalendarOnIconClick
                                        className="select from-date"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={reportedOn}
                                        onChange={(date) => setReportedOn(date)}
                                        dateFormat="dd/MM/yyyy"
                                        maxDate={new Date()}
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                    {/* <img src={calendar} alt="" /> */}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div>
                                    <label>Actual <span className="required-asterisk">*</span></label>
                                    {/* <Form.Control
                                        type="number"
                                        // value={achievedPercentage}
                                        // onChange={handleAchievedPercentageChange}
                                        value={actualValue}
                                        onChange={handleActualChange}
                                    />
                                    {errors.achievedPercentage && (
                                        <div className="text-danger">{errors.achievedPercentage}</div>
                                    )} */}
                                    {singleAssignedToSlaData[0]?.ValueType === 'Date' ? (
                                        <DatePicker
                                            showIcon
                                            toggleCalendarOnIconClick
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={actualValue}
                                            onChange={handleActualChange}
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            minDate={singleAssignedToSlaData[0]?.BaseLine ? new Date(singleAssignedToSlaData[0].BaseLine) : null}
                                            onKeyDown={(e) => {
                                                e.preventDefault();
                                            }}
                                        />
                                    ) : (
                                        <Form.Control
                                            type="number"
                                            value={actualValue}
                                            onChange={handleActualChange}
                                        />
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div>
                                    <label>Achieved % <span className="required-asterisk">*</span></label>
                                    <Form.Control
                                        type="number"
                                        value={achievedPercentage}
                                    // onChange={handleAchievedPercentageChange}
                                    />
                                    {/* {errors.achievedPercentage && (
                                        <div className="text-danger">{errors.achievedPercentage}</div>
                                    )} */}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div>
                                    <label>Department </label>
                                    <Form.Control
                                        type="text"
                                        value={singleAssignedToSlaData[0]?.DepartmentName}
                                        // value={departmentName}
                                        // onChange={(e) => setDepartmentID(e.target.value)}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div>
                                    <label>Assigned Score</label>
                                    <Form.Control
                                        type="text"
                                        value={assignedScore}
                                        disabled // Prevent user from editing
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div>
                                    <label>Checklist</label>
                                    <Form.Control
                                        type="text"
                                        value={checklist}
                                        onChange={(e) => setChecklist(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <label>Status<span className="required-asterisk">*</span></label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={filteredStatusOptions}
                                        placeholder="Select"
                                        value={status}
                                        onChange={handleStatusChange}
                                        onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, status: "" }))}
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                    {errors.status && (
                                        <div className="text-danger">{errors.status}</div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {isEndDateExpired && (
                    <div className="text-danger mt-2">
                        The end date has expired. You cannot update this SLA.
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleClose} />
                {!isEndDateExpired && <SBSaveUpdateBtn btnName="Submit" onClickEffect={handleSubmit} />}
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateSlaModal;
